import { AssetEvent } from './asset.event';
import { EventRegistry } from '../../../../../domain/event/event.registry';
export class LegacyPhotosUnlinkedFromAssetEvent extends AssetEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `asset-class/${payload.assetClassId}/asset/${payload.id}`,
            type: LegacyPhotosUnlinkedFromAssetEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
LegacyPhotosUnlinkedFromAssetEvent.type = 'com.treeplotter.api.photo.legacyPhotosUnlinkedFromAsset.v1';
EventRegistry.register(LegacyPhotosUnlinkedFromAssetEvent.type, LegacyPhotosUnlinkedFromAssetEvent);
//# sourceMappingURL=legacy-photos-unlinked-from-asset.event.js.map